module.exports = __webpack_public_path__ + "img/thumbnail_PolarBear_m_normal.c611f2ad.png";